import React, { useState, useEffect } from "react";

import DoubtText from "./DoubtText";    
import DoubtsEmpty from "./empty/DoubtsEmpty";
import DoubtsLoading from "./loading/DoubtsLoading";

import { Grid, Typography } from "@material-ui/core";

const Doubts = (props) => {
    const [userDoubts, setUserDoubts] = useState([]);
    useEffect(() => {
        setUserDoubts(props?.data);
    }, [props?.data]);

    return (
        <>
            {
                userDoubts ?
                    <>
                        <Grid container>
                            <Typography
                                align="center"
                                style={{
                                    fontSize: "24px",
                                    color: "#ad2831",
                                    fontWeight: "bold",
                                    paddingTop: "10px",
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingBottom: "5px",
                                }}
                            >
                                Your Doubts
                            </Typography>
                        </Grid>
                        <Grid container>
                            {
                                userDoubts.length > 0 ?
                                    userDoubts?.map((doubt, i) => {
                                        return (
                                            <DoubtText doubtID={doubt} key={i} />
                                        );
                                    })
                                    : <DoubtsEmpty />
                            }
                        </Grid>
                    </>
                    : <DoubtsLoading />
            }
        </>
    );
}

export default Doubts;